// @ts-check
import { useRef, useCallback, useEffect } from 'react';

/** Returns a setTimeout-like function that clears the previous timeout when re-invoked or when the component unmounts. */
export function useTimeout() {
  /** @type { React.MutableRefObject<NodeJS.Timeout> } */
  const handleRef = useRef();

  useEffect(() => () => clearTimeout(handleRef.current), []);

  return useCallback((handler, timeout) => {
    clearTimeout(handleRef.current);
    handleRef.current = setTimeout(handler, timeout);
  }, []);
}
